import { useState } from "react";
import video from "../../assests/video.mp4";
import { BiError } from "react-icons/bi";
import { CustomButton } from "../reusble_components/buttons/secondaryButton";
import { useStores } from "../../store/index";
import video2 from "../../assests/screenrecordvideo.gif";

export default function RequestPermission({
  popUpInitialValue,
  handlePopup,
  screenRecord,
  handleStartRecord,
}) {
  const [error, setError] = useState(null);
  const [waiting, setWaiting] = useState(false);
  const { PopupStore } = useStores();

  const closeThisPopUP = () => {
    handlePopup();
  };

  const handleScreenRecordAccess = () => {
    PopupStore.setAllowScreenRecord(true);
    handlePopup();
  };

  const handleCameraAccess = async () => {
    setWaiting(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true,
      });
      setWaiting(false);
      handlePopup();
    } catch (error) {
      if (
        error.name === "NotAllowedError" ||
        error.name === "PermissionDeniedError"
      ) {
        // Permission denied by the user
        setError("User denied access to the microphone and camera");
        setWaiting(false);
        // You can display a message to the user here.
      } else {
        // Handle other errors
        console.error("Error accessing the microphone and camera:", error);
        setWaiting(false);
      }
      setWaiting(false);
      handlePopup();
    }
  };

  return (
    <>
      {popUpInitialValue ? (
        <>
          <div className="absolute w-scaeen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40">
            <div className="fixed text-start inset-0 bg-bg3 z-50 flex flex-col  rounded py-5 md:w-[40%] lg:w-[40%] w-[90%] h-[58vh] md:h-[70vh] m-auto shadow-lg overflow-y-auto no-scrollbar">
              {/* <div className="flex flex-col  items-center w-[100%] h-full py-2 ">
              <AiFillCloseCircle
                className="text-primary absolute text-2xl cursor-pointer  top-2 right-2"
                onClick={closeThisPopUP}
              />
            </div> */}
              {screenRecord ? (
                <img
                  className="w-[90%] mx-auto border-5 border-primary  h-full"
                  src={screenRecord ? video2 : video}
                  autoPlay
                  loop
                />
              ) : (
                <video
                  className="w-[90%] mx-auto border-5 border-primary  h-full"
                  src={screenRecord ? video2 : video}
                  autoPlay
                  loop
                />
              )}

              <p className="font-bold w-[90%] mx-auto pb-2">
                {screenRecord
                  ? "Share your Entire Full screen"
                  : "Allow access to your microphone and camera"}
              </p>
              <p className="w-[90%] mx-auto text-sm pb-2">
                {screenRecord
                  ? "Please provide access to your screen recording by clicking the below button"
                  : "Please provide access to your microphone and camera by clicking the below button"}
              </p>
              {/* <button
              onClick={handleCameraAccess}
              className="px-4 py-2 w-[50%] mx-auto rounded-3xl bg-primary hover:bg-transparent border border-transparent hover:border-primary text-white hover:text-primary"
            >
              Request Permission
            </button> */}
              <div className="flex items-center justify-center">
                {screenRecord ? (
                  <CustomButton
                    onClick={() => {
                      // Execute immediately to preserve user gesture context
                      if (handleStartRecord) {
                        handleStartRecord();
                      }
                    }}
                    waiting={waiting}
                    buttonText="Request Permission"
                  />
                ) : (
                  <CustomButton
                    onClick={handleCameraAccess}
                    waiting={waiting}
                    buttonText="Request Permission"
                  />
                )}
              </div>
              {error !== null ? (
                <p className="text-red-500 text-xs justify-center mt-1 flex items-center">
                  <BiError />
                  {error}
                </p>
              ) : null}
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
